import { render, staticRenderFns } from "./ReplacementsMercList.vue?vue&type=template&id=494510a4&scoped=true&"
import script from "./ReplacementsMercList.vue?vue&type=script&lang=js&"
export * from "./ReplacementsMercList.vue?vue&type=script&lang=js&"
import style0 from "./ReplacementsMercList.vue?vue&type=style&index=0&id=494510a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494510a4",
  null
  
)

export default component.exports